export const INVALID_TWILIO_CREDENTIALS_MESSAGE = 'Invalid Twilio credentials';
function isPresent(value) {
    return typeof value === 'string' ? value.trim().length > 0 : value !== undefined && value !== null;
}
export function normalizeTwilioCredentials(credentials) {
    const hasAccountSid = isPresent(credentials.accountSid);
    const hasToken = isPresent(credentials.token);
    const hasApiKey = isPresent(credentials.apiKey);
    const hasSecretKey = isPresent(credentials.secretKey);
    const hasSender = isPresent(credentials.messageProfileId) || isPresent(credentials.from);
    const hasCompleteLegacyMode = hasAccountSid && hasToken && !hasApiKey && !hasSecretKey;
    const hasCompleteApiKeyMode = hasAccountSid && !hasToken && hasApiKey && hasSecretKey;
    let authenticateByToken = credentials.authenticateByToken;
    if (authenticateByToken === undefined) {
        if (hasCompleteLegacyMode === hasCompleteApiKeyMode) {
            throw new Error(INVALID_TWILIO_CREDENTIALS_MESSAGE);
        }
        authenticateByToken = hasCompleteLegacyMode;
    }
    const hasValidAuthMode = authenticateByToken ? hasCompleteLegacyMode : hasCompleteApiKeyMode;
    if (!hasValidAuthMode || !hasSender) {
        throw new Error(INVALID_TWILIO_CREDENTIALS_MESSAGE);
    }
    return {
        ...credentials,
        authenticateByToken,
    };
}
//# sourceMappingURL=twilio-credentials.js.map